import { Layout } from "@components/organisms/layout"
import { GatsbyBrowser } from "gatsby"
import React from "react"

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <Layout {...props}>{element}</Layout>
